import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { makeGetSummaryOrderCond } from '../../lib/selector';

import PerfectScrollBar from 'react-perfect-scrollbar';
import { Col } from 'react-bootstrap';

import {
  numberFormat,
  _convertTpToPrice,
  _getOrderStatus,
  mapOrderChanel,
  _formatDate2,
  _convertActTypeToStr,
  _getOrdCondStatus,
  _getOrdCondStr,
} from '../../utils';

import Page from '../print/Page';
import PrintButton from '../print/PrintButton';
import FormSearchSKLDK from './layout/formSearchSKLDK';
import Paging from '../paging';

import logo from '../../assets/img/logo.png';

import { take, takeRight } from 'lodash';

import ExportSaoKeLenhDieuKien from '../../lib/exports/SaoKeLenhDieuKien';
import { translate } from 'react-i18next';

class SaoKeLenhDieuKien extends React.Component {
  state = {
    contentShow: [],
    // paging
    continued: false,
    totalCount: 0,
    page: 1,

    params: null,
  };

  componentDidUpdate(preProps) {
    const { listOrder } = this.props;

    if (listOrder && listOrder !== preProps.listOrder) {
      this.setState({ totalCount: listOrder ? listOrder.length : 0 });
      this.handleQueryPage(1);
    }
  }

  handleQueryPage = (page) => {
    const pageSize = 15;
    const { listOrder } = this.props;
    if (!listOrder || !listOrder.length) {
      this.setState({ contentShow: [], totalCount: 0, page: 1 });

      return;
    }
    const _totalPage = Math.ceil(listOrder.length / pageSize);

    const _takeContent = take(listOrder, pageSize * page);
    const _contentShow = takeRight(
      _takeContent,
      _takeContent.length - pageSize * (page - 1)
    );
    console.log(_contentShow);
    this.setState({
      contentShow: _contentShow,
      page,
      continued: page < _totalPage,
    });
  };

  _saveParams = (params) => {
    // console.log(params)
    this.setState({ params });
  };

  render() {
    const { account, listOrder, t } = this.props;

    const { contentShow, params } = this.state;
    // console.log(account, params);
    return (
      <Fragment>
        <PerfectScrollBar style={{ height: 'calc( 100% - 50px )' }}>
          <div className="d-flex">
            <Col className="d-flex flex-column">
              <div className="d-flex flex-row mt-3 mb-2">
                <span
                  className="text-white mx-auto"
                  style={{ fontSize: '18px' }}
                >
                  {t('txt-label-order-cond-history')}
                </span>
              </div>
              <FormSearchSKLDK
                account={account}
                saveParams={this._saveParams}
              />
              <div className="d-flex justify-content-between align-items-center mt-3 mb-2">
                <label className="text-white ml-2 fz-14 text-uppercase">
                  {t('txt-detail')}
                </label>
                <div className="d-flex align-items-baseline">
                  <ExportSaoKeLenhDieuKien
                    csvData={listOrder ? listOrder : []}
                    fileName="sao-ke-lenh-dieu-kien"
                    fromDate={params && params.data.fromDate}
                    toDate={params && params.data.toDate}
                    symbol={params && (params.data.symbol || t('txt-all'))}
                    typeOrder={
                      params &&
                      (params.data.ordertype === 'CNL'
                        ? 'Tất cả'
                        : _getOrdCondStr(params.data.ordertype))
                    }
                    status={
                      params &&
                      (params.data.status === ''
                        ? 'Tất cả'
                        : _getOrdCondStatus(params.data.status))
                    }
                    accountCode={account && account.subAcntNo}
                    accountName={account && account.vsdAcntNo}
                  />
                  <PrintButton id={'sao-ke-lenh-dieu-kien'} />
                </div>
              </div>
              <Page id="sao-ke-lenh-dieu-kien">
                <table className="table table-bordered tbl-list">
                  <thead>
                    <tr>
                      <th className="text-center">{t('txt-stt')}</th>
                      <th className="text-center">
                        {t('txt-label-tran-date')}
                      </th>
                      <th className="text-center">{t('txt-trade-acronym')}</th>
                      <th className="text-center">{t('txt-symbol')}</th>
                      <th className="text-center">{t('txt-order-no')}</th>
                      <th className="text-center">{t('txt-label-from')}</th>
                      <th className="text-center">{t('txt-label-to')}</th>
                      <th className="text-center">
                        {t('txt-label-condition')}
                      </th>
                      <th className="text-center">{t('txt-vol')}</th>
                      <th className="text-center">{t('txt-status')}</th>
                      <th className="text-center">{t('txt-match-vol')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contentShow &&
                      !!contentShow.length &&
                      contentShow.map((item, i) => {
                        if (item.modiCnclTp === '3') return null;
                        return (
                          <tr key={i}>
                            <td className="text-center">
                              {15 * (this.state.page - 1) + i + 1}
                            </td>
                            <td className="text-center">{item.timeQuote}</td>
                            <td className="text-center mx-auto">
                              <div
                                className={
                                  'text-uppercase mx-auto trade_side_' +
                                  (item.side === 'B' ? '1' : '2')
                                }
                              >
                                {item.side === 'B'
                                  ? t('txt-buy')
                                  : t('txt-sell')}
                              </div>
                            </td>
                            <td className="text-center">{item.symbol}</td>
                            <td className="text-center">{item.ordrNo}</td>
                            <td className="text-center">{item.createddt}</td>
                            <td className="text-center">{item.expireddt}</td>
                            <td className="text-left">
                              {_convertActTypeToStr(item.activetype)}
                            </td>
                            <td className="text-right">
                              {numberFormat(item.qtty, 0, '0')}
                            </td>
                            <td className={'text-center ordStt_' + item.status}>
                              {_getOrdCondStatus(item.status)}
                            </td>
                            <td className="text-right">
                              {numberFormat(item.execQtty, 0, '0')}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
                {(!contentShow || !contentShow.length) && (
                  <p className="text-center fz-14 mt-2 title-time">
                    {t('txt-no-data-found')}
                  </p>
                )}
              </Page>
              {listOrder && (
                <Paging
                  handleQueryPage={this.handleQueryPage}
                  continued={this.state.continued}
                  totalCount={this.state.totalCount}
                  pageSize={15}
                  page={this.state.page}
                />
              )}
              <Page id="sao-ke-giao-dich" style={{ display: 'none' }}>
                <div className="d-flex flex-column bg-light">
                  <div
                    className="position-relative d-flex justify-content-center align-items-center"
                    style={{ height: '75px' }}
                  >
                    <img
                      src={logo}
                      alt="logo"
                      className="position-absolute"
                      style={{ top: '0', left: '0' }}
                    />
                    <span className="fz-18 font-weight-bold text-uppercase">
                      {'SAO KÊ LỆNH ĐIỀU KIỆN'}
                    </span>
                  </div>
                  <div className="d-flex mt-2">
                    <Col className="d-flex flex-column">
                      <div className="d-flex">
                        <span className="fz-14 w_125">{'Tên BC:'}</span>
                        <span className="fz-14 f_i">
                          {'Sao kê lệnh điều kiện'}
                        </span>
                      </div>
                      <div className="d-flex">
                        <span className="fz-14 w_125">{'Số tiểu khoản:'}</span>
                        <span className="fz-14 f_i">
                          {account && account.subAcntNo}
                        </span>
                      </div>
                      <div className="d-flex">
                        <span className="fz-14 w_125">{'Số VSD:'}</span>
                        <span className="fz-14 f_i">
                          {account && account.vsdAcntNo}
                        </span>
                      </div>
                    </Col>
                    <Col className="d-flex flex-column">
                      <div className="d-flex">
                        <span className="fz-14 w_125">{'Từ ngày:'}</span>
                        <span className="fz-14 f_i">
                          {params && _formatDate2(params.data.createddt)}
                        </span>
                      </div>
                      <div className="d-flex">
                        <span className="fz-14 w_125">{'Đến ngày:'}</span>
                        <span className="fz-14 f_i">
                          {params && _formatDate2(params.data.expireddt)}
                        </span>
                      </div>
                      <div className="d-flex">
                        <span className="fz-14 w_125">{'Mã CK:'}</span>
                        <span className="fz-14 f_i">
                          {params && (params.data.symbol || 'Tất cả')}
                        </span>
                      </div>
                      <div className="d-flex">
                        <span className="fz-14 w_125">{'Loại lệnh:'}</span>
                        <span className="fz-14 f_i">
                          {params &&
                            (params.data.ordertype === 'CNL'
                              ? 'Tất cả'
                              : _getOrdCondStr(params.data.ordertype))}
                        </span>
                      </div>
                      <div className="d-flex">
                        <span className="fz-14 w_125">{'Trạng thái:'}</span>
                        <span className="fz-14 f_i">
                          {params &&
                            (params.data.status === ''
                              ? 'Tất cả'
                              : _getOrdCondStatus(params.data.status))}
                        </span>
                      </div>
                    </Col>
                  </div>
                </div>
                <div className="d-flex bg-light">
                  <table className="table table-bordered mt-2 table-light">
                    <thead>
                      <tr>
                        <th className="text-center">{t('txt-stt')}</th>
                        <th className="text-center">
                          {t('txt-label-tran-date')}
                        </th>
                        <th className="text-center">
                          {t('txt-trade-acronym')}
                        </th>
                        <th className="text-center">{t('txt-symbol')}</th>
                        <th className="text-center">{t('txt-order-no')}</th>
                        <th className="text-center">{t('txt-label-from')}</th>
                        <th className="text-center">{t('txt-label-to')}</th>
                        <th className="text-center">
                          {t('txt-label-condition')}
                        </th>
                        <th className="text-center">{t('txt-vol')}</th>
                        <th className="text-center">{t('txt-status')}</th>
                        <th className="text-center">{t('txt-match-vol')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listOrder &&
                        !!listOrder.length &&
                        listOrder.map((item, i) => {
                          if (item.modiCnclTp === '3') return null;
                          return (
                            <tr key={i}>
                              <td className="text-center">{i + 1}</td>
                              <td className="text-center">{item.timeQuote}</td>
                              <td className="text-center mx-auto">
                                <div
                                  className={
                                    'text-uppercase mx-auto trade_side_' +
                                    (item.side === 'B' ? '1' : '2')
                                  }
                                >
                                  {item.side === 'B'
                                    ? t('txt-buy')
                                    : t('txt-sell')}
                                </div>
                              </td>
                              <td className="text-center">{item.symbol}</td>
                              <td className="text-center">{item.ordrNo}</td>
                              <td className="text-center">{item.createddt}</td>
                              <td className="text-center">{item.expireddt}</td>
                              <td className="text-left">
                                {_convertActTypeToStr(item.activetype)}
                              </td>
                              <td className="text-right">
                                {numberFormat(item.qtty, 0, '0')}
                              </td>
                              <td
                                className={'text-center ordStt_' + item.status}
                              >
                                {_getOrdCondStatus(item.status)}
                              </td>
                              <td className="text-right">
                                {numberFormat(item.execQtty, 0, '0')}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </Page>
            </Col>
          </div>
        </PerfectScrollBar>
      </Fragment>
    );
  }
}

const makeMapStateToProps = () => {
  const getSummaryOrderCond = makeGetSummaryOrderCond();

  const mapStateToProps = (state) => {
    return {
      listOrder: getSummaryOrderCond(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(SaoKeLenhDieuKien)
);
